import path from "@/lib/utils/path";
import { __profilename } from "@/lib/variables";
import imageMetadata from "@assets/images/metadata.json";
var profileMetadata = imageMetadata.profile;
var loadProfile = function (scene, user) {
    var username = user.username, picture = user.picture;
    var metadata = profileMetadata[picture] || profileMetadata[0];
    scene.load.image("profile-".concat(username), path.join(__profilename, metadata.src));
    scene.load.start();
};
var AssetHelper = {
    loadProfile: loadProfile,
};
export default AssetHelper;
